import request from '@/utils/request'
import URL from './urlTranslator'

export function getImGroup(data) {
  return request({
    url: URL.external.im.getImGroup,
    method: 'post',
    data
  })
}

export function createOrJoin(data) {
  return request({
    url: URL.external.im.createOrJoin,
    method: 'post',
    data
  })
}

export function getOpenCacheKey(data) {
  return request({
    url: URL.external.im.getOpenCacheKey,
    method: 'post',
    data
  })
}
